const api = ""

// Frontend Routes

export const F_INDEX = "/"
export const F_START_ABOUT = "/about"
export const F_START_PARTNER = "/partner"
export const F_START_IMPRESSUM = "/impressum"
export const F_START_DATENSCHUTZ = "/datenschutz"
export const F_START_AGB = "/agb"
export const F_START_MINORINFO = "/minorinfo"
export const F_START_LOGIN = "/login"
export const F_START_FORGOT_PASSWORD = "/forgotpassword"
export const F_START_RESET_PASSWORD = "/resetpassword"
export const F_START_EMAIL_VALIDATION = "/emailvalidation"

export const F_SCHOOLHUNTING = "/schoolhunting"

export const F_VERWALTUNG = "/administration"
export const F_VERWALTUNG_BOOKS = "/administration/books"
export const F_VERWALTUNG_BOOKS_SHORT = "/books"
export const F_VERWALTUNG_LICENCES = "/administration/licences"
export const F_VERWALTUNG_LICENCES_SHORT = "/licences"

export const F_TRADING = "/app"
export const F_TRADING_SEARCH = "/app/search"
export const F_TRADING_SEARCH_SHORT = "/search" // problems with nested routing inside Trading.jsx
export const F_TRADING_ACTIVE = "/app/active"
export const F_TRADING_ACTIVE_SHORT = "/active"
export const F_TRADING_CHAT = "/app/chat"
export const F_TRADING_CHAT_DETAIL = "/app/chat?detail" // only for mobile, todo needs better implementation
export const F_TRADING_CHAT_SHORT = "/chat"
export const F_TRADING_HISTORY = "/app/history"
export const F_TRADING_HISTORY_SHORT = "/history"

// Backend Routes

export const BACKEND_CONTACTS_ADDCONTACT = `${api}/?action=contacts&type=addcontact`
export const BACKEND_CONTACTS_ALLCONTACTS = `${api}/?action=contacts&type=allcontacts`
export const BACKEND_CONTACTS_ALLCITIES_BL = `${api}/?action=contacts&type=allcities&bl=`
